var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrivateInvitation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6780AA",
  fillRule: "nonzero",
  d: "M24.875 73a1 1 0 0 0-1-1H14.1q-.055 0-.1-47a1 1 0 0 1 1-1h76a1 1 0 0 1 1 1v27.36a1 1 0 0 0 2 0V25a3 3 0 0 0-3-3H15a3 3 0 0 0-3 3v46.9c0 1.16.94 2.1 2.1 2.1h8.775v23.472c0 .982 1.268 1.376 1.825.567L41.226 74h20.093a1 1 0 0 0 0-2h-20.62a1 1 0 0 0-.824.434l-15 21.818z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M24.07 34.987a1 1 0 0 1 0-2h45.897a1 1 0 0 1 0 2zM24 44.685a1 1 0 0 1 0-2h45.898a1 1 0 0 1 0 2zm0 9.698a1 1 0 0 1 0-2h23.019a1 1 0 0 1 0 2zm0 9.699a1 1 0 0 1 0-2h23.02a1 1 0 0 1 0 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6780AA",
  fillRule: "nonzero",
  d: "M106.985 74.154c0-12.334-10-22.333-22.333-22.333-12.335 0-22.334 9.999-22.334 22.334 0 12.333 10 22.332 22.334 22.332s22.333-9.999 22.333-22.332zm2 0c0 13.439-10.895 24.334-24.333 24.334-13.44 0-24.334-10.895-24.334-24.334s10.895-24.333 24.334-24.333 24.333 10.894 24.333 24.334z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M91.927 83C92.51 83 93 82.491 93 81.846v-9.692c0-.645-.49-1.154-1.073-1.154h-13.91c-.584 0-1.073.508-1.073 1.154v9.692c0 .646.489 1.154 1.073 1.154zM79 69v-3a6 6 0 1 1 12 0v3h.927C93.632 69 95 70.421 95 72.154v9.692C95 83.58 93.632 85 91.927 85h-13.91c-1.706 0-3.073-1.42-3.073-3.154v-9.692c0-1.733 1.367-3.154 3.073-3.154zm2 0h8v-3a4 4 0 1 0-8 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M84 76.732v2.976a1 1 0 0 0 2 0v-2.975a2 2 0 1 0-2 0z"
}))));
export default SvgPrivateInvitation;